// extracted by mini-css-extract-plugin
export var blogContent = "BlogView-module--blogContent--fade4";
export var blogContentTitle = "BlogView-module--blogContentTitle--c6a54";
export var blogHtml = "BlogView-module--blogHtml--ef5af";
export var blogHtmlTagContainer = "BlogView-module--blogHtmlTagContainer--bbe78";
export var blogHtmlTagLink = "BlogView-module--blogHtmlTagLink--036f4";
export var blogImg = "BlogView-module--blogImg--791a3";
export var blogLinkContainer = "BlogView-module--blogLinkContainer--21754";
export var blogViewMainContainer = "BlogView-module--blogViewMainContainer--018fb";
export var categoryLink = "BlogView-module--categoryLink--f93ee";
export var childImg = "BlogView-module--childImg--6eaa7";
export var childImgContainer = "BlogView-module--childImgContainer--27b1c";
export var childImgIcon = "BlogView-module--childImgIcon--c7830";
export var childImgMainContainer = "BlogView-module--childImgMainContainer--0bdff";
export var contentContainer = "BlogView-module--contentContainer--21c1c";
export var decChild = "BlogView-module--decChild--b0b80";
export var imgContainer = "BlogView-module--imgContainer--9532e";
export var imgText = "BlogView-module--imgText--7c4e2";
export var navigationMainContainer = "BlogView-module--navigationMainContainer--24729";
export var socialContainer = "BlogView-module--socialContainer--956fe";
export var socialIcon = "BlogView-module--socialIcon--e7d38";
export var socialLink = "BlogView-module--socialLink--c7bf5";
export var titleDecContainer = "BlogView-module--titleDecContainer--bd4a9";
export var viewImg = "BlogView-module--viewImg--a7684";